export default function Privacidad() {
  const fecha = new Date().toLocaleDateString("es-AR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div className="max-w-3xl mx-auto px-4 pt-36 pb-10">
      <h1 className="text-2xl md:text-3xl font-bold">Políticas de Privacidad</h1>
      <p className="text-sm text-gray-600 mt-1">Última actualización: {fecha}</p>

      <p className="mt-6">
        En <strong>WetSoul</strong> nos tomamos muy en serio tu privacidad. A continuación
        te contamos de forma simple cómo recopilamos, usamos y protegemos tus datos
        cuando navegás o comprás en nuestra tienda.
      </p>

      <h2 className="mt-8 font-semibold text-lg">¿Qué datos personales recolectamos?</h2>
      <ul className="list-disc pl-5 mt-2 space-y-1">
        <li>Nombre y apellido.</li>
        <li>Email y teléfono.</li>
        <li>Dirección de envío y facturación (localidad, provincia, CP).</li>
        <li>Historial de compras y navegación en nuestra tienda.</li>
        <li>Información de pago (procesada por pasarelas seguras; no almacenamos datos completos de tarjeta).</li>
      </ul>

      <h2 className="mt-8 font-semibold text-lg">¿Para qué usamos tus datos?</h2>
      <ul className="list-disc pl-5 mt-2 space-y-1">
        <li><strong>Procesar y enviar</strong> tus pedidos.</li>
        <li><strong>Comunicarnos</strong> sobre tu compra o consultas.</li>
        <li><strong>Novedades/promos</strong> solo si te suscribís (podés darte de baja cuando quieras).</li>
        <li><strong>Mejorar tu experiencia</strong> en la web.</li>
      </ul>
      <p className="mt-2">
        No vendemos, alquilamos ni compartimos tu información personal con fines comerciales.
      </p>

      <h2 className="mt-8 font-semibold text-lg">Seguridad</h2>
      <p className="mt-2">
        Usamos conexión segura (SSL) y proveedores confiables. Las pasarelas de pago cumplen estándares
        internacionales de seguridad.
      </p>

      <h2 className="mt-8 font-semibold text-lg">Comunicaciones</h2>
      <p className="mt-2">
        Te escribimos solo por temas de tu pedido o si <strong>te suscribiste</strong> a novedades.
        Podés darte de baja cuando quieras desde el pie de los correos o escribiéndonos a{" "}
        <a className="underline" href="mailto:wetsoulconsultas@gmail.com">
          wetsoulconsultas@gmail.com
        </a>.
      </p>

      <h2 className="mt-8 font-semibold text-lg">Uso de cookies</h2>
      <p className="mt-2">
        Nuestro sitio usa <strong>cookies necesarias</strong> para que todo funcione (carrito, sesión) y{" "}
        <strong>cookies analíticas</strong> para entender el uso del sitio <strong>si aceptás</strong> desde
        el banner. Podés desactivarlas en la configuración de tu navegador (el sitio seguirá funcionando).
      </p>

      <h2 className="mt-8 font-semibold text-lg">Tus derechos y contacto</h2>
      <p className="mt-2">
        Si querés <strong>acceder, actualizar o eliminar</strong> tus datos, escribinos a{" "}
        <a className="underline" href="mailto:wetsoulconsultas@gmail.com">
          wetsoulconsultas@gmail.com
        </a>. Cualquier actualización de esta política se publicará en esta misma página.
      </p>
    </div>
  );
}